import React, {Fragment, useContext, useState, useEffect } from "react";
import {
  Button,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  ModalHeader,
  Col,
  Row,
} from "reactstrap";
import { RootStoreContext } from "../../core/store/rootStore";
import LoadingOverlay from "react-loading-overlay";
import {toast} from "react-toastify";
import Role from "../../shared/enums/roleEnum";

const UserModal = () => {

  const rootStore = useContext(RootStoreContext);
  const { newUser, save, edit, loadingSave, loadUser, getRole } = rootStore.userStore;
  const { closeModal, modal } = rootStore.modalStore;

  let [editableUser, setEditableUser, userId] = useState(newUser());
  let [showPasswordTemp, setShowPasswordTemp] = useState(false);
  let [showCrifPasswordTemp, setShowCrifPasswordTemp] = useState(false);
  let [showCrifForTestingPasswordTemp, setShowCrifForTestingPasswordTemp] = useState(false);

  useEffect(() => {
    if (modal.content && modal.content.id) {
      userId = modal.content.id;

      let apiUser = {...editableUser};

      loadUser(userId).then(userResult => {
        apiUser.id = userResult.id;
        apiUser.name = userResult.name;
        apiUser.surname = userResult.surname;
        apiUser.username = userResult.username;
        apiUser.code = userResult.code;
        apiUser.language = userResult.language;
        apiUser.role = userResult.role;
        apiUser.mail = userResult.mail;
        apiUser.companyName = userResult.companyName;
        apiUser.crifUserName = userResult.crifUserName;
        apiUser.crifUserNameForTesting = userResult.crifUserNameForTesting ?? "";

        setShowPasswordTemp(true);
        setShowCrifPasswordTemp(true);
        setShowCrifForTestingPasswordTemp(true);

        setEditableUser(apiUser);
      });
    }
  }, [modal.content]);

  function saveUser(event) {
    event.preventDefault();

    if (editableUser.id) {
      edit(editableUser.id, editableUser).then(result => {
        if (result.success) {
          toast.success("User has been edited successfully");

          closeModal(result.success);
        }
      });
    }
    else {
      save(editableUser).then(result => {
        if (result.success) {
          toast.success("User has been saved successfully");

          closeModal(result.success);
        }
      });
    }

  }

  const inputChange = (e) => {
    const { name, value } = e.target;
    let realValue = value;

    if (JSON.parse(e.target.getAttribute("data-number")))
      realValue = Number(realValue);

    setEditableUser((lastUpdate) => ({
      ...lastUpdate,
      [name]: realValue,
    }));
  };

  function RoleInput() {
    if (getRole === Role.ADMIN) {
      return <FormGroup row>
        <Label for="role" sm={4}>Rôle</Label>
        <Col sm={8}>
          <Input type="select" name="role" id="role" value={editableUser.role} onChange={inputChange} data-number={true}>
            <option value={1}>{Role.ROLE_ADMIN}</option>
            <option value={2}>{Role.ROLE_USER}</option>
          </Input>
        </Col>
      </FormGroup>
    }

    return null;
  }

  function focus(func, elemId) {
    func(false);

    //Add id to the table
    window.requestAnimationFrame(() => setFocus(elemId));
  }

  function setFocus(elemId) {
    let element = document.getElementById(elemId);
    element.focus();
  }

  return (
    <Fragment>
      <Form onSubmit={saveUser}>
        <LoadingOverlay
            active={loadingSave}
            spinner>
          <ModalHeader>Gestion de l'utilisateur</ModalHeader>
          <ModalBody>
            <Row>
              <Col md={6}>
                <FormGroup row>
                  <Label for="name" sm={4}>Prénom</Label>
                  <Col sm={8}>
                    <Input
                        type="text"
                        name="name"
                        id="name"
                        required="required"
                        value={editableUser.name}
                        onChange={inputChange}
                    />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label for="surname" sm={4}>Nom de famille</Label>
                  <Col sm={8}>
                    <Input
                        type="text"
                        name="surname"
                        id="surname"
                        required="required"
                        value={editableUser.surname}
                        onChange={inputChange}
                    />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label for="username" sm={4}>Nom d'utilisateur</Label>
                  <Col sm={8}>
                    <Input
                        type="text"
                        name="username"
                        id="username"
                        required="required"
                        readOnly={editableUser.id}
                        value={editableUser.username}
                        onChange={inputChange}
                    />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label for="password" sm={4}>Mot de passe</Label>
                  <Col sm={8}>
                    {!showPasswordTemp &&
                    <Input
                        type="password"
                        name="password"
                        id="password"
                        required={!editableUser.id}
                        value={editableUser.password}
                        onChange={inputChange}
                    />
                    }
                    {showPasswordTemp &&
                      <Input
                          type="password"
                          name="fakePlaceholder"
                          id="fakePlaceholder"
                          defaultValue="MYPASSWORD"
                          onFocus={() => focus(setShowPasswordTemp, "password")}
                      />
                    }
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label for="language" sm={4}>Langue</Label>
                  <Col sm={8}>
                    <Input type="select" name="language" id="language" value={editableUser.language} onChange={inputChange} data-number={true}>
                      <option value={1}>Français</option>
                      <option value={2}>German</option>
                      <option value={3}>English</option>
                    </Input>
                  </Col>
                </FormGroup>
                <RoleInput />
                <FormGroup row>
                  <Label for="email" sm={4}>E-Mail</Label>
                  <Col sm={8}>
                    <Input
                        type="mail"
                        name="mail"
                        id="mail"
                        value={editableUser.mail}
                        onChange={inputChange}
                    />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label for="code" sm={4}>Code</Label>
                  <Col sm={8}>
                    <Input
                        type="text"
                        name="code"
                        id="code"
                        value={editableUser.code}
                        onChange={inputChange}
                    />
                  </Col>
                </FormGroup>
              </Col>
              <Col md={6}>
                <div className="col-12 pl-0">
                  <b>Environnement de test</b>
                </div>
                <FormGroup row>
                  <Label for="code" sm={4}>Nom d'utilisateur CRIF</Label>
                  <Col sm={8}>
                    <Input
                        type="text"
                        name="crifUserNameForTesting"
                        id="crifUserNameForTesting"
                        value={editableUser.crifUserNameForTesting}
                        onChange={inputChange}
                    />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label for="code" sm={4}>Mot de passe CRIF</Label>
                  <Col sm={8}>
                    {!showCrifPasswordTemp &&
                    <Input
                        type="password"
                        name="crifPasswordForTesting"
                        id="crifPasswordForTesting"
                        value={editableUser.crifPasswordForTesting}
                        onChange={inputChange}
                    />
                    }
                    {showCrifPasswordTemp &&
                    <Input
                        type="password"
                        name="fakeTestPlaceholder"
                        id="fakeTestPlaceholder"
                        defaultValue="MYPASSWORD"
                        onFocus={() => focus(setShowCrifPasswordTemp, "crifPasswordForTesting")}
                    />
                    }
                  </Col>
                </FormGroup>
                <hr />
                <div className="col-12 pl-0">
                  <b>Environnement de production</b>
                </div>
                <FormGroup row>
                  <Label for="code" sm={4}>Nom d'utilisateur CRIF</Label>
                  <Col sm={8}>
                    <Input
                        type="text"
                        name="crifUserName"
                        id="crifUserName"
                        value={editableUser.crifUserName}
                        onChange={inputChange}
                    />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label for="code" sm={4}>Mot de passe CRIF</Label>
                  <Col sm={8}>
                    {!showCrifForTestingPasswordTemp &&
                    <Input
                        type="password"
                        name="crifPassword"
                        id="crifPassword"
                        value={editableUser.crifPassword}
                        onChange={inputChange}
                    />
                    }
                    {showCrifForTestingPasswordTemp &&
                    <Input
                        type="password"
                        name="fakeCrifPrdPlaceholder"
                        id="fakeCrifPrdPlaceholder"
                        defaultValue="MYPASSWORD"
                        onFocus={() => focus(setShowCrifForTestingPasswordTemp, "crifPassword")}
                    />
                    }
                  </Col>
                </FormGroup>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={closeModal}>
              Annuler
            </Button>
            <Button type="submit" color="primary" className={"ml-2"}>
              Sauvegarder
            </Button>
          </ModalFooter>
        </LoadingOverlay>
      </Form>
    </Fragment>
  );
};

export default UserModal;
